'use client'

import { styled } from '@mui/material'
import { PageLayout } from '../pageLayout'

export const StyledSupport = styled(PageLayout)(({ theme }) => ({
  '.jakarta .MuiTypography-root': {
    fontFamily: 'Plus Jakarta Sans Variable',
  },
  
  // Original styles for support items
  '.support-items > .MuiGrid2-root': {
    '.MuiTypography-root': {
      textAlign: 'center',
      '&.label': {
        fontWeight: 800,
        marginBottom: 0
      }
    },
    sup: {
      fontSize: '80%',
      top: '-0.25em',
    },
    img: {
      display: 'block',
      margin: theme.spacing(0, 'auto', 1),
    },
    [theme.breakpoints.up('md')]: {
      '.MuiTypography-root': {
        textAlign: 'left'
      },
      img: {
        margin: theme.spacing(0, 0, 1),
      }
    }
  },
  
  //I added styles for the updated grid structure
  '.support-items': {
    // Make grid items left-aligned on desktop
    [theme.breakpoints.up('sm')]: {
      '& .MuiGrid-item': {
        textAlign: 'left',
        '& > *': {
          textAlign: 'left'
        }
      },
      
      //Add vertical dividers between columns on desktop
      '& .MuiGrid-item + .MuiGrid-item': {
        borderLeft: `1px solid ${theme.palette.grey[300]}`
      },
      
      //Left-align images on desktop
      '& img': {
        margin: theme.spacing(0, 0, 1)
      }
    },
    
    //Add horizontal dividers on mobile only
    [theme.breakpoints.down('sm')]: {
      '& .row-container + .row-container': {
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        paddingTop: theme.spacing(3),
        marginTop: theme.spacing(3)
      },
      
      //Center-align images and text on mobile
      '& .MuiGrid-item': {
        textAlign: 'center',
        '& > *': {
          textAlign: 'center'
        }
      },
      
      '& img': {
        margin: theme.spacing(0, 'auto', 1)
      }
    }
  }
}))